export default "__VITE_ASSET__49b11bfa__"